import moment from 'moment';
import { Datagrid, ExportButton, FilterButton, FunctionField, List, SelectInput, TextInput } from 'react-admin';

const statusColors: { [key: string]: string } = {
	active: 'bg-green-100',
	completed: 'bg-gray-200',
	cancelled: 'bg-red-100',
};

const statusLabels: { [key: string]: string } = {
	active: 'פעיל',
	completed: 'הושלם',
	cancelled: 'בוטל',
};

const PrivateServicePackagesList = () => {
	return (
		<List
			actions={
				<div style={{ display: 'flex', gap: 8 }}>
					<FilterButton />
					<ExportButton />
				</div>
			}
			sort={{ field: 'createdAt', order: 'DESC' }}
			filters={[
				<TextInput source="member" label="member id" />,
				<TextInput source="expert" label="expert id" />,
				<TextInput source="service" label="service id" />,
				<SelectInput
					source="status"
					choices={[
						{ id: 'active', name: 'פעיל' },
						{ id: 'completed', name: 'הושלם' },
						{ id: 'cancelled', name: 'בוטל' },
					]}
				/>,
			]}
		>
			<Datagrid bulkActionButtons={false}>
				<FunctionField
					textAlign="right"
					label="נרכש"
					sortBy="createdAt"
					render={(record: any) => (
						<span className="whitespace-pre-line">
							<div>{moment(record.purchased_at || record.createdAt).format('DD.MM.YY')}</div>
							<div className="text-xs">{moment(record.purchased_at || record.createdAt).format('HH:mm')}</div>
						</span>
					)}
				/>
				<FunctionField
					label="חבר/ה"
					render={(record: any) => (
						<div>
							<div className="font-medium text-[0.85rem]">
								{record.member?.first_name} {record.member?.last_name}
							</div>
							<div className="text-xs text-gray-500">{record.member?.email}</div>
						</div>
					)}
				/>
				<FunctionField
					label="מומחה/ית"
					render={(record: any) => record.expert?.name || record.expert?.english_name || '—'}
				/>
				<FunctionField
					label="שירות"
					render={(record: any) => (
						<div className="line-clamp-1 w-44 truncate text-[0.8rem]">
							{record.service?.title?.he ?? record.service?.title?.en ?? '—'}
						</div>
					)}
				/>
				<FunctionField
					textAlign="right"
					label="פגישות"
					render={(record: any) => (
						<span className="text-xs px-2 py-0.5 rounded-full bg-amber-100">
							{record.sessions_used ?? 0}/{record.total_sessions}
						</span>
					)}
				/>
				<FunctionField
					textAlign="right"
					label="סכום ששולם"
					render={(record: any) => `${record.total_price_paid ?? 0}₪`}
				/>
				<FunctionField
					textAlign="right"
					label="מחיר לפגישה"
					render={(record: any) => {
						const total = Number(record.total_sessions) || 0;
						const paid = Number(record.total_price_paid) || 0;
						if (!total) return '—';
						const perSession = paid / total;
						return `${Number.isInteger(perSession) ? perSession : perSession.toFixed(2)}₪`;
					}}
				/>
				<FunctionField
					textAlign="right"
					label="שווי שנוצל"
					render={(record: any) => {
						const total = Number(record.total_sessions) || 0;
						const paid = Number(record.total_price_paid) || 0;
						const used = Number(record.sessions_used) || 0;
						if (!total) return '—';
						const consumed = (paid / total) * used;
						return `${Number.isInteger(consumed) ? consumed : consumed.toFixed(2)}₪`;
					}}
				/>
				<FunctionField
					textAlign="right"
					label="סטטוס"
					render={(record: any) => (
						<span className={`text-xs px-2 py-0.5 rounded-full ${statusColors[record.status] || ''}`}>
							{statusLabels[record.status] || record.status}
						</span>
					)}
				/>
				<FunctionField
					textAlign="right"
					label="תשלום"
					render={(record: any) => {
						const url = record.payment?.sale_invoice_url;
						const id = record.payment?.payme_sale_id;
						if (!record.payment) return <span className="text-[0.7rem]">—</span>;
						return (
							<div className="text-[0.7rem]">
								{url && id ? (
									<a
										href={url}
										target="_blank"
										rel="noopener noreferrer"
										className="text-blue-600 underline"
										onClick={(e) => e.stopPropagation()}
									>
										{id}
									</a>
								) : (
									<div>{id || '—'}</div>
								)}
								<div className="text-gray-500">{record.payment?.sale_status || ''}</div>
							</div>
						);
					}}
				/>
			</Datagrid>
		</List>
	);
};

export default PrivateServicePackagesList;
